import React from 'react';
import { translate } from 'react-i18next';
import {Card, CardText, CardHeader} from 'material-ui/Card';
import {List} from 'material-ui/List';
import firebase from '../firebase';
import compose from '../compose';
import user from '../Auth/user';
import {Toolbar, ToolbarGroup, ToolbarTitle} from 'material-ui/Toolbar';
import LoadingIndicator from '../Navigation/LoadingIndicator';
import Previous from 'material-ui/svg-icons/navigation/chevron-left';
import Next from 'material-ui/svg-icons/navigation/chevron-right';
import FirstPage from 'material-ui/svg-icons/navigation/first-page';
import LastPage from 'material-ui/svg-icons/navigation/last-page';
import IconButton from 'material-ui/IconButton';
import './SettlementList.css';

class SettlementList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      settlements: [],
      settlementsPerPage: 15,
      firstPage: true,
      lastPage: false,
      loadingIndicator: 'flex',
      settlementInfo: ''
    };
  }
  componentDidMount = () => {
    const { user, firebase } = this.props;

    if(user.shopkeeperId) {
      firebase.database().ref('shopkeepers/' + user.shopkeeperId + '/settlement/')
        .once('value', (snapshot) => {
          this.setState({settlementInfo: snapshot.val()});
        });

      this.getFirstSettlements(user.shopkeeperId);
    }
  }

  getFirstSettlements = (shopkeeperId) => {
    const {firebase} = this.props;

    firebase.database().ref('shopkeepers/' + shopkeeperId + '/settlements/')
      .orderByKey()
      .limitToLast(this.state.settlementsPerPage)
      .once('value', (querySettlements) => {
        this.updateFirstSettlements(querySettlements);
        this.setState({loadingIndicator: 'none'});
      });
  }
  getLastSettlements = () => {
    const {firebase} = this.props;

    firebase.database().ref('shopkeepers/' + this.props.user.shopkeeperId + '/settlements/')
      .orderByKey()
      .limitToFirst(this.state.settlementsPerPage)
      .once('value', (querySettlements) => {
        this.updateSettlements(querySettlements);
      });
    this.setState({lastPage: true, firstPage: false});
  }
  getNextSettlements = () => {
    const {firebase} = this.props;

    firebase.database().ref('shopkeepers/' + this.props.user.shopkeeperId + '/settlements/')
      .orderByKey()
      .limitToLast(this.state.settlementsPerPage)
      .endAt(this.state.settlements[this.state.settlements.length - 1].key.slice(0, -1))
      .once('value', (querySettlements) => {
        this.updateSettlements(querySettlements);
      });
    this.setState({firstPage: false});
  }
  getPreviousSettlements = () => {
    const {firebase} = this.props;

    firebase.database().ref('shopkeepers/' + this.props.user.shopkeeperId + '/settlements/')
      .orderByKey()
      .limitToFirst(this.state.settlementsPerPage)
      .startAt(this.state.settlements[0].key + 'a')
      .once('value', (querySettlements) => {
        this.updateSettlements(querySettlements);
      });
    this.setState({lastPage: false});
  }

  updateFirstSettlements = (querySettlements) => {
    const {firebase} = this.props;

    const settlements = [];
    querySettlements.forEach((data) => {
      const settlement = {
        key: data.key,
        ...data.val()
      };
      settlements.unshift(settlement);
    });
    if(settlements.length === 0) {
      this.setState({lastPage: true});
      return; 
    }

    this.setState({settlements, firstSettlement: settlements[0].key, firstPage: true});

    firebase.database().ref('shopkeepers/' + this.props.user.shopkeeperId + '/settlements/')
      .orderByKey()
      .limitToFirst(1)
      .once('value', (settlement) => {
        settlement.forEach((lastSettlement) => {
          if (settlements[settlements.length - 1].key === lastSettlement.key) {
            this.setState({lastPage: true});
          } else {
            this.setState({lastPage: false});
          }
          this.setState({lastSettlement: lastSettlement.key});
        });
      });
  }

  updateSettlements = (querySettlements) => {
    const settlements = [];
    querySettlements.forEach((data) => {
      const settlement = {
        key: data.key,
        ...data.val()
      };
      settlements.unshift(settlement);
    });
    this.setState({settlements});
    if (settlements[0].key === this.state.firstSettlement) {
      this.setState({firstPage: true});
    }
    if (settlements[settlements.length - 1].key === this.state.lastSettlement) {
      this.setState({lastPage: true});
    }
  }

  render() {
    const {t, user} = this.props;

    const settlements = this.state.settlements.map((settlement) => (
      <Card key={settlement.key}>
        <CardHeader
          title={new Date(settlement.register_date).toLocaleDateString(user.language)}
          subtitle={settlement.settlementTotalSum + ' €'}
          actAsExpander={true}
          showExpandableButton={true}
        />
        <CardText expandable={true}>
          {t('settlement.registerDate')}
          {new Date(settlement.register_date).toLocaleString(user.language, {year: '2-digit', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'})}
          <br />
          {t('settlement.paymentDate')}
          {new Date(settlement.payment_date).toLocaleDateString(user.language)}
          <br />
          <br />
          <table>
            <thead>
              <tr>
                <td />
                <td style={{textAlign: 'right', color: '#9e9e9e', fontSize: '10px'}}>{t('settlement.excludedVat')}</td>
                <td style={{textAlign: 'right', color: '#9e9e9e', fontSize: '10px'}}>{t('settlement.salesVat')}</td>
                <td style={{textAlign: 'right', color: '#9e9e9e', fontSize: '10px'}}>{t('settlement.includedVat')}</td>
              </tr>
            </thead>
            <tbody>
              {settlement.totalValue0Vat > 0 ? <tr>
                <td>{t('settlement.sales0Vat')}</td>
                <td style={{textAlign: 'right'}}>{settlement.excludeVatValue0Vat + ' €'}</td>
                <td style={{textAlign: 'right'}}>{settlement.vatValue0Vat + ' €'}</td>
                <td style={{textAlign: 'right'}}>{settlement.totalValue0Vat + ' €'}</td>
              </tr> : null}
              {settlement.totalValue10Vat > 0 ? <tr>
                <td>{t('settlement.sales10Vat')}</td>
                <td style={{textAlign: 'right'}}>{settlement.excludeVatValue10Vat + ' €'}</td>
                <td style={{textAlign: 'right'}}>{settlement.vatValue10Vat + ' €'}</td>
                <td style={{textAlign: 'right'}}>{settlement.totalValue10Vat + ' €'}</td>
              </tr> : null}
              {settlement.totalValue14Vat > 0 ? <tr>
                <td>{t('settlement.sales14Vat')}</td>
                <td style={{textAlign: 'right'}}>{settlement.excludeVatValue14Vat + ' €'}</td>
                <td style={{textAlign: 'right'}}>{settlement.vatValue14Vat + ' €'}</td>
                <td style={{textAlign: 'right'}}>{settlement.totalValue14Vat + ' €'}</td>
              </tr> : null}
              {settlement.totalValue24Vat > 0 ? <tr>
                <td>{t('settlement.sales24Vat')}</td>
                <td style={{textAlign: 'right'}}>{settlement.excludeVatValue24Vat + ' €'}</td>
                <td style={{textAlign: 'right'}}>{settlement.vatValue24Vat + ' €'}</td>
                <td style={{textAlign: 'right'}}>{settlement.totalValue24Vat + ' €'}</td>
              </tr> : null}
              <tr className='separated'>
                <td style={{fontWeight: 'bold'}}>{t('settlement.totalSales')}</td>
                <td style={{textAlign: 'right'}}>{settlement.excludeVatValueTotalSales + ' €'}</td>
                <td style={{textAlign: 'right'}}>{settlement.vatValueTotalSales + ' €'}</td>
                <td style={{textAlign: 'right', fontWeight: 'bold'}}>{settlement.totalSalesSum + ' €'}</td>
              </tr>
              <tr className='blankRow'/>
              {settlement.commissionPercentCommission > 0 ? <tr>
                <td>{t('settlement.commission') + this.state.settlementInfo.commission_percent + ' %'}</td>
                <td style={{textAlign: 'right'}}>{'- ' + settlement.excludeVatCommissionPercent + ' €'}</td>
                <td style={{textAlign: 'right'}}>{'- ' + settlement.vatValueCommissionPercent + ' €'}</td>
                <td style={{textAlign: 'right'}}>{'- ' + settlement.commissionPercentCommission + ' €'}</td>
              </tr> : null}
              {settlement.commissionPerSaleCommission > 0 ? <tr>
                <td>{t('settlement.commissionPerSale') + '(' + settlement.salesAmount + ' x ' + this.state.settlementInfo.per_sale_commission + ' €)'}</td>
                <td style={{textAlign: 'right'}}>{'- ' + settlement.excludeVatCommissionPerSale + ' €'}</td>
                <td style={{textAlign: 'right'}}>{'- ' + settlement.vatValueCommissionPerSale + ' €'}</td>
                <td style={{textAlign: 'right'}}>{'- ' + settlement.commissionPerSaleCommission + ' €'}</td>
              </tr> : null}
              {settlement.commissionStaticCommission > 0 ? <tr>
                <td>{t('settlement.commissionBase')}</td>
                <td style={{textAlign: 'right'}}>{'- ' + settlement.excludeVatCommissionStatic + ' €'}</td>
                <td style={{textAlign: 'right'}}>{'- ' + settlement.vatValueCommissionStatic + ' €'}</td>
                <td style={{textAlign: 'right'}}>{'- ' + settlement.commissionStaticCommission + ' €'}</td>
              </tr> : null}
              <tr className='separated'>
                <td style={{fontWeight: 'bold'}}>{t('settlement.commissionTotal')}</td>
                <td style={{textAlign: 'right'}}>{'- ' + settlement.excludeVatCommission + ' €'}</td>
                <td style={{textAlign: 'right'}}>{'- ' + settlement.commissionVat + ' €'}</td>
                <td style={{textAlign: 'right', fontWeight: 'bold'}}>{'- ' + settlement.commissionTotal + ' €'}</td>
              </tr>
              <tr className='blankRow'/>
              <tr>
                <td>{t('settlement.totalSales')}</td>
                <td />
                <td />
                <td style={{textAlign: 'right'}}>{settlement.totalSalesSum + ' €'}</td>
              </tr>
              <tr >
                <td>{t('settlement.commissionTotal')}</td>
                <td />
                <td />
                <td style={{textAlign: 'right'}}>{'- ' + settlement.commissionTotal + ' €'}</td>
              </tr>
              <tr className='separated'>
                <td style={{fontWeight: 'bold'}}>{t('settlement.totalSettlement')}</td>
                <td />
                <td />
                <td style={{textAlign: 'right', fontWeight: 'bold'}}>{settlement.settlementTotalSum + ' €'}</td>
              </tr>
            </tbody>
          </table>
        </CardText>
      </Card>
    ));

    return (
        <Card className='cardStyle'>
          <Toolbar>
            <ToolbarGroup>
              <ToolbarTitle text={t('settlement.settlements')} />
            </ToolbarGroup>
          </Toolbar>
          <CardText style={{textAlign: 'left', position: 'relative'}}>
            <List>
              {settlements}
            </List>
            <div>
              <IconButton
                onTouchTap={() => this.getFirstSettlements(this.props.user.shopkeeperId)}
                disabled={(this.state.firstPage)}>
                <FirstPage />
              </IconButton>
              <IconButton
                onTouchTap={this.getPreviousSettlements}
                disabled={(this.state.firstPage)}>
                <Previous />
              </IconButton>
              <IconButton
                onTouchTap={this.getNextSettlements}
                disabled={(this.state.lastPage)}>
                <Next />
              </IconButton>
              <IconButton
                onTouchTap={this.getLastSettlements}
                disabled={(this.state.lastPage)}>
                <LastPage />
              </IconButton>
            </div>
            <LoadingIndicator display={this.state.loadingIndicator} />
          </CardText>
      </Card>
    );
  }
}

const enhance = compose(translate(), firebase, user);

export default enhance(SettlementList);



// WEBPACK FOOTER //
// ./src/Settlement/SettlementList.js